export const DAILY_LIMIT_ERROR_EVENT = 'dailyLimitError';

export function showDailyLimit(data = {}) {
	const event = new CustomEvent(DAILY_LIMIT_ERROR_EVENT, {
		detail: {
			...data
		}
	});

	window.dispatchEvent(event);
}
